module.exports = __webpack_public_path__ + "static/media/html5.454a400c.png";